module.exports = __webpack_public_path__ + "static/img/kefu.90dc7507.jpg";